import { render, staticRenderFns } from "./StartCreatePostDetails.vue?vue&type=template&id=318d94a2&"
import script from "./StartCreatePostDetails.vue?vue&type=script&lang=js&"
export * from "./StartCreatePostDetails.vue?vue&type=script&lang=js&"
import style0 from "./StartCreatePostDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports